import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const chatlogApi = {
  getConfigReadChatColor: (request) => {
    const { config } = request
    return instance().get('/api/chat-log/cms/config-read-chat-color', config)
  },
  postUpdateConfigReadChatColor: (request) => {
    const { data } = request
    return instance().post('/api/chat-log/cms/config-read-chat-color', data)
  },
  putReadAllChat: (body) => {
    return instance().put('/api/admin/live-chat/admin-read-all', body)
  },
  putBlockUser: (body) => {
    return instance().put('/api/admin/block-user', body)
  },
  postMarkAsUnRead: (body) => {
    return instance().post('/api/chat-log/cms/mark-as-unread', body)
  }
}
export default chatlogApi



// WEBPACK FOOTER //
// ./src/api/chatlog.js